module.exports = __webpack_public_path__ + "img/C03TechWoodenRoad_ua.b9230520.webp";